import { times } from 'lodash';

const uuid = () =>
  times(4, () => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(36)).join('-');

export default uuid;
